import { useModal } from "../../../utils/ModalContext";
import { FiX } from "react-icons/fi";
import OopsModalStyleWrapper from "./OopsModal.style";
import hoverShape from "../../../assets/images/icon/hov_shape_L.svg";
import hoverShapeSmall from "../../../assets/images/icon/hov_shape_s.svg";
import data from "../../../assets/data/socialShare";
import oopsImg from "../../../assets/images/octopuses/Oops.png";

const OopsModal = () => {

  const { oopsModalHandle, message } = useModal();
  console.log("rendering oops modal");
  
  return (
    <>
      <OopsModalStyleWrapper className="modal_overlay">
        <div className="mint_modal_box">
          <div className="mint_modal_content">
            <div className="modal_header">
              <h2>Something Went Wrong</h2>
              <button onClick={() => oopsModalHandle()}>
                <FiX />
              </button>
            </div>
            <div className="modal_body text-center">
              <div className="modal-message">
                <h5>{message}</h5>
              </div>
              {/* <div className="modal-img">
                <img src={oopsImg} alt="ALPHA OCTOPUS no wallet" style={{height:200}}/>
              </div> */}
            </div>
            <div className="modal_bottom_shape_wrap">
              <span className="modal_bottom_shape shape_left">
                <img src={hoverShape} alt="bithu nft hover shape" />
              </span>
              <span className="modal_bottom_shape shape_right">
                <img src={hoverShape} alt="bithu nft hover shape" />
              </span>
            </div>
          </div>
        </div>
      </OopsModalStyleWrapper>
    </>
  );
};

export default OopsModal;
